import styled from '@emotion/styled';
import { Stack } from '@pairy/pds-react';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const StackTopRightWrapper = styled(Stack)<{ rightOffset?: number }>`
  position: fixed;
  z-index: ${VIEWER_Z_INDEX.desktopLayer};
  right: ${({ rightOffset }) => rightOffset ?? 0}px;
  display: flex;
  width: auto;
  padding: 32px 48px;
`;
